var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClasses},_vm._l((_vm.requirements),function(req,idx){return _c('div',{key:idx},[_c('card-requirement',{attrs:{"requirement":req,"leftMargin":_vm.indentRight[idx]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }